module.exports = __webpack_public_path__ + "img/7.92d8506e.png";